module.exports = __webpack_public_path__ + "09b872a0732e99245f46d07cc3d7f563.png";